import clsx from 'clsx';

type HintVariant = 'error' | 'info' | 'success';

type HintFieldProps = {
  message?: string;
  variant?: HintVariant;
  className?: string;
};

const variantClasses: Record<HintVariant, string> = {
  error: 'text-red-500',
  info: 'text-dark-blue/70',
  success: 'text-green-600',
};

function renderHintIcon(variant: HintVariant) {
  if (variant === 'success') {
    return (
      <path
        clipRule="evenodd"
        d="M16.704 5.29a1 1 0 010 1.414l-7.07 7.07a1 1 0 01-1.414 0l-3.03-3.03a1 1 0 111.414-1.414l2.323 2.323 6.363-6.363a1 1 0 011.414 0z"
        fillRule="evenodd"
      />
    );
  }

  if (variant === 'info') {
    return (
      <path
        clipRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-11a1 1 0 100-2 1 1 0 000 2zm-1 2a1 1 0 000 2v3a1 1 0 102 0v-3a1 1 0 00-1-1z"
        fillRule="evenodd"
      />
    );
  }

  return (
    <path
      clipRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
      fillRule="evenodd"
    />
  );
}

export function HintField({ message, variant = 'error', className }: HintFieldProps) {
  const hidden = !message;

  return (
    <p
      aria-live="polite"
      className={clsx(
        'pointer-events-none absolute top-full left-0 z-10 mt-0.5 flex items-center gap-1 text-sm! transition-all duration-200 ease-out',
        variantClasses[variant],
        hidden ? '-translate-y-1 opacity-0' : 'translate-y-0 opacity-100',
        className,
      )}
    >
      <svg className="h-3.5 w-3.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
        {renderHintIcon(variant)}
      </svg>
      {message ?? ''}
    </p>
  );
}
